<ng-container *transloco="let t">
  <pxw-modal-dialog #workingHoursDialog [title]="t('workingHours.dialogTitle')" type="alert">
    <pxw-icon icon="info" />
    <ng-template #modalContent>
      <pxw-working-hours-message-details [workingDays]="workingDays()" />
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
